import { useState } from "react";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { disconnectSocket } from "shared/services/socket";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import { Icons } from "assets";
import { toastMessage } from "shared/components/common/toast";
import styles from "./style.module.scss";
import classNames from "classnames";
import ConfirmationModal from "shared/modal/confirmation";

const MobileLogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
  };
  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };
  const handleLogout = () => {
    disconnectSocket();
    dispatch(resetAuthReducer());
    toastMessage("success", "Logged out successfully");
    navigate(routeConstant.login.path);
  };

  return (
    <>
      <div
        onClick={handleOpenConfirmationModal}
        className={classNames(
          styles.logoutButtonContainer,
          "lg:hidden flex items-center justify-between cursor-pointer",
        )}
      >
        <div className="flex items-center gap-2">
          <Icons.Logout className={classNames(styles.logoutIcon)} />
          <label>Logout</label>
        </div>
        <span className={classNames(styles.chevronRightIcon)}>
          <Icons.ChevRight />
        </span>
      </div>
      <ConfirmationModal
        show={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        subtitle="Are you sure you want to logout?"
        actionButtonText="Yes, Logout"
        cancelButtonText="Not Now"
        handleSubmit={handleLogout}
      />
    </>
  );
};

export default MobileLogoutButton;
